import type { RailwayRunner } from '@cli-types/next-adapter/railway.js'
import { RAILWAY_CLI_VERSION } from '@cli-constants/tool-versions.js'

export function npxRunner(): RailwayRunner {
  return {
    bin: 'npx',
    prefix: ['-y', `@railway/cli@${RAILWAY_CLI_VERSION}`],
    source: 'npx',
    version: RAILWAY_CLI_VERSION
  }
}
